var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fragment', [_c('div', {
    staticClass: "page_title_wrap type2"
  }, [_c('h3', {
    staticClass: "page_title_text"
  }, [_vm._v("비공개 댓글")])]), _c('div', {
    staticClass: "comment_wrap"
  }, [_c('div', {
    staticClass: "textarea_wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    ref: "textAreaRef",
    attrs: {
      "rows": "1",
      "placeholder": _vm.placeholder,
      "title": "연재에 다양한 의견을 전달해 주세요.",
      "disabled": _vm.disabled,
      "maxlength": "200"
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value;
      }, _vm.inputHandler]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn_input",
    attrs: {
      "type": "button",
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_c('span', {
    staticClass: "btn_text"
  }, [_vm._v("등록")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }